import { createGlobalStyle } from 'styled-components';
import {
  accent,
  black,
  bgPurple,
  orange,
  lightOrange,
  containerWidth,
  smallContainerWidth,
  largeContainerWidth,
  textGrey,
  dirtyWhite,
  textRed,
  white,
  lgGreen,
  textLightGrey,
  rowBg,
  blue,
  lgGrey2,
  textDarkGrEy,
  lgGrey,
  popoverBg,
  lgGrey3,
} from 'constants/theme';
import styled from 'styled-components';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';

export default createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  html {
    font-size: 62.5%;
    height: initial;
  }

  body {
    font-family: Roboto, sans-serif;
    line-height: 1;
    font-size: 1.6rem;
    color: #000;
    background-color: #fff;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "pnum";
    font-feature-settings: "pnum";
    font-variant-numeric: proportional-nums;
  }
  
  @media (min-width: 320px) and (max-width: 767px) {
    body {
      max-width: 100vw;
      overflow-x: hidden !important;
      position: absolute;
      height: auto;
      padding: 0px;
      margin: 0px;
    }
  }
  

.modal-shiftfix {
  overflow: hidden;
}
.modal-open {
  padding-right: 0 !important;
}
  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    color: ${textGrey};
  }
  
  .btn-secondary:focus {
    box-shadow: none !important;
  }
  
  .btn-secondary:hover {
    color: inherit !important;
  }
  
  .bordered-popover {
    // max-width: 600px;
    .popover{
      background-color: ${white};
      color: ${black};
      border: none;
      box-shadow: 0 1px 3px 2px rgba(0, 0, 0, 0.05);
    }
  }

  button:focus {
    outline: none;
  }

  pre {
    display: block;
    padding: 2rem;
    margin-top: 4rem;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    border-radius: 5px;
    color: ${accent};
    border: 1px solid #ddd;
    font-family: "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace;
  }
  .website-container {
    width: 100%;
    max-width: ${containerWidth};
    margin: 0 auto !important;
    // float: none !important;
    padding-top: 106px;
  }
  @media screen and (max-width: 845px) {
    .website-container {
      padding-top: 80px !important;
    }  
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .website-container {
      padding-top: 73px;
    }  
  }
  @media only screen 
  and (min-width: 1024px) 
  and (max-height: 1366px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1.5) {
    .website-container {
      padding-top: 80px !important;
    }
  }

  video {
    max-width: 100%;
  }
  
  .popover {
    z-index: 1;
  }

  p {
    margin-bottom: 2rem;
  }
  div[data-reach-dialog-overlay] {
    z-index: 2210;
    background-color: rgba(35,29,53,0.8);
  }
  div.modal-backdrop {
    top: 106px;
    background-color: rgba(35,29,53,0.8);
  }
  div.modal.fade.show {
    top: 106px;
    box-shadow: 0px 0px 6px 5px #f5f5f5;
   	// box-shadow: 0 -4px 8px 0 rgba(0,0,0,0.05);
  }
  @media screen and (max-width: 1024px) {
    div.modal.fade.show {
      top: 80px;
    }
`;
// Search Related pages Fonts
export const SearchFonts = styled.div`
  width: 100%;
  max-width: ${largeContainerWidth};
  margin: 0 auto !important;
  .filter-section {
    background-color: #f9f9f9;
    box-shadow: 4px 0 8px 0 rgba(0, 0, 0, 0.05);
    padding-bottom: 30px;
  }
  @media screen and (max-width: 1024px) {
    .results-table {
      max-width: 100%;
      flex: 0 0 100%;
    }
    .deskContent {
      display: none;
    }
    .phoneContent {
      display: block;
    }
  }
  @media screen and (min-width: 1025px) {
    .deskContent {
      display: block;
    }
    .phoneContent {
      display: none !important;
    }
  }
`;
export const FilterMobile = styled.div`
  .card {
    background-color: #f9f9f9;
    border: none;
  }
  .card-header {
    position: fixed;
    width: 100%;
    top: 0;
    background-color: ${white};
    z-index: 2;
    height: 80px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    h2 {
      color: ${textRed};
      font-size: 26px;
      margin: 0;
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
  .card-body {
    padding: 0 20px 0 20px;
    background-color: #f9f9f9;

    h2 {
      display: none;
    }
    button {
      display: none;
    }
  }
  .card-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 80px;
    background-color: ${white};
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    button.reset {
      background-color: ${accent};
      height: 40px;
      width: 162px;
      border: none;
      color: ${white};
      font-size: 18px;
      font-weight: bold;
      &:disabled {
        background-color: ${popoverBg};
      }
    }
    button.apply {
      background-color: ${lgGreen};
      height: 40px;
      width: 162px;
      border: none;
      color: ${white};
      font-size: 18px;
      font-weight: bold;
      &:disabled {
        background-color: ${lgGrey3};
      }
    }
  }
`;

// HOME PAGE SECTION
export const Fonts = styled.div`
  width: 100%;
  max-width: ${smallContainerWidth};
  margin: 0 auto !important;
  font-weight: 300;
  &.search-page-width {
    max-width: ${largeContainerWidth};
  }
  p {
    font-size: 16px;
    color: ${textGrey};
    line-height: 24px;
    font-weight: 300;
  }
  h1 {
    font-size: 32px;
    color: ${textRed};
    line-height: 38px;
    font-weight: 300;
  }
  h2 {
    line-height: 30px;
    font-size: 26px;
    color: ${textRed};
    font-weight: 300;
  }
  h3 {
    line-height: 25px;
    font-size: 22px;
    color: ${textRed};
    font-weight: 300;
  }
  button {
    font-size: 16px;
    color: ${lightOrange};
    font-weight: 300;
  }
  &:focus {
    outline: none;
    border: none;
  }
  &:active {
    outline: none;
    border: none;
  }
  a {
    color: ${lightOrange};
    text-decoration: underline;
    text-transform: capitalize;
    font-weight: 300;
  }
`;
export const HeroArea = styled.div`
  background-color: ${bgPurple};
  background-image: url(/images/logo-symbol-right.png);
  background-position-x: -170px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-y: center;
  position: relative;
  color: ${white};
  width: 100%;
  min-height: 542px;
  .hero-row {
    padding: 60px 0;
    align-items: center;
  }
  h1 {
    color: ${textRed};
    font-size: 32px;
    padding: 20px 0;
  }
  .hero-text-area {
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: left;
    padding: 15px;
    p {
      color: ${white};
    }

    button {
      background-color: transparent;
      border: none;
      padding: 85px 0 0 0;
      text-align: left;
      font-weight: bold;
      text-align: left;
      color: ${orange};
      svg {
        font-size: 28px;
        display: block;
      }
      &: focus {
        outline: none;
      }
    }
  }
  .home-img {
    height: 422px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 30px 40px 0 rgba(0, 0, 0, 0.2) !important;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    padding: 0;
    background-position-x: -170px;
    background-size: 150%;
    background-repeat: no-repeat;
    background-position-y: top;
    h1 {
      white-space: nowrap;
    }
  }

  @media (min-width: 320px) and (max-width: 767px) {
    background-position-x: -260px;
    background-repeat: no-repeat;
    background-size: 235%;
    background-position-y: top;
    .hero-row {
      padding: 40px 0;
      flex-direction: column-reverse;
      margin: 0;
    }
    .hero-text-area {
      text-align: center;
      padding: 0 15px;
      button {
        padding-top: 30px;
        text-align: center;
        svg {
          font-size: 28px;
          display: block;
          justify-content: center;
          width: 100%;
        }
      }
    }
    .hero-img-area {
      width: 100%;
      padding: 0;
      .home-img {
        height: auto;
        margin: 0 15px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
          0 30px 40px 0 rgba(0, 0, 0, 0.2) !important;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .hero-row {
      margin: 0 10px 0 10px;
    }
  }
`;

export const SimpleSearch = styled.div`
  background-color: ${white};
  height: 100%;
  line-height: 40px;
  color: ${textRed};
  .row {
    align-items: center;
    justify-content: center;
    display: flex;
  }
  h2 {
    margin-top: 60px;
    margin-bottom: 14px;
    text-align: center;
  }
  h3 {
    color: ${black} !important;
    font-size: 16px !important;
    font-weight: bold !important;
    line-height: 30px !important;
    &.check-box-title {
      margin-bottom: 5px;
    }
    &.postalCode-title {
      display: inline-block;
    }
  }
  .checkbox-filter {
    display: flex;
    width: 100%;
  }
  .search-button {
    background-color: ${lgGreen};
    color: ${white};
    font-weight: bold;
    width: 100%;
    border: none;
    margin-top: 40px;
    line-height: 51px;
    &.last {
      display: none;
    }
  }
   .select-country {
     .select-button {
       background-color: ${white};
       border-radius: 0px;
       border: 1px solid ${lightOrange};
       width: 100%;
       line-height: 49px;
       text-align: left;
       padding: 0 15px;
       color: ${textLightGrey};
       &:focus {
         outline: none;
       }
       &:hover {
         outline: none;
       }
       svg {
        float: right;
        font-size: 18px;
        top: 15px;
        right: 16px;
        position: absolute;
        color: ${lightOrange};
       }
     }
     .dropdown-menu.show  {
       width: 100%;
     }
   } 
   .search-col {
    margin-bottom: 10px;
   }
  
  .drop-down-find {
    text-align: center;
  }
  .card {
    border: none;
  }
  .more-button {
    border: none;
    background-color: ${white};
    text-decoration-line: underline;
    text-decoration: underline;
    text-align: center;
    margin-bottom: 50px;
    color: ${orange}
    &: hover {
      outline: none;
    }
  }
  .dropdown-position {
    margin-top: 20px;
  }
  .check-box-align {
    display: flex;
    padding: 0;
    height: 30px;
    align-items: center;
    justify-content: left;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    p {
      color: ${black};
      margin-left: 25px;
      margin-top: 4px;
    }
    input {
      display: inline-block;
      position: absolute;
      opacity: 0;
      margin-top: -8px
      line-height: 100px;
      cursor: pointer;
      z-index: 2;
    }
    

    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 16px;
      width: 16px;
      background-color: ${white};
      border: 1px solid ${lightOrange};
    }

    input:checked ~ .checkmark {
      background-color: ${lgGreen};
      border: none;
    }

    .checkmark:after {
      content: '';
      position: absolute;
      display: none;
    }

    input:checked ~ .checkmark:after {
      display: block;
    }

    .checkmark:after {
      left: 6px;
      top: 2px;
      width: 4px;
      height: 9px;
      border: solid ${white};
      border-width: 0 1px 1px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  .general-form-input {
    input{
      ::-ms-clear {
        display: none;
     }
      padding: 0 15px;
      width: 100%;
      line-height: 49px;
      height: 49px;
      border: 1px solid ${lightOrange};
      border-radius: 0;
      &:active,
      &:focus {
        box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
        outline: none;
      }
      &:disabled {
        border: 1px solid #cecece;
        background-color: #e6e6e6;
      } 
    }
  } 
    .keyword-design {
      margin-bottom: 40px;
      position: relative;
      line-height: 49px;
      input {
        text-overflow: ellipsis;
        padding: 0 15px;
        border-radius: 0px;
        height: 49px;
        width: 100%;
        border: 1px solid ${lightOrange};
        &:active,
        &:focus {
          box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
          outline: none;
        }
        ::-ms-clear {
          display: none;
       }
      }
      svg {
        font-size: 18px;
        position: absolute;
        top: 16px;
        right: 30px
        color: ${lightOrange};
      }
    }
    
    //Postal code with popover
    .postal-code-popover {
      display: flex;
      justify-content: space-between;
      line-height: 30px;
      .btn-secondary {
        background: transparent;
        border: none;
        display: inline-block;
        float: right;
        padding: 0;
        outline: none;
        svg {
          font-size: 18px;
        }
        &:focus {
          outline: none;
          border: none;
          background: transparent;
          border-radius: 0;
        }
        &:active {
          outline: none;
          border: none;
          background: transparent;
          border-radius: 0;
        }
        
       
        &:hover {
          color: ${orange};
          outline: none;
          border: none;
          background: transparent;
          border-radius: 0;
        }
      }
    }
     .popover-body {
        background-color: ${popoverBg};
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.05), 0 10px 20px 0 rgba(0,0,0,0.1);
      }
  
  
  @media (min-width: 760px) and (max-width: 1024px) {
    margin: 0 15px;
     .select-country {
       .select-button {
         padding: 0 10px;
         svg {
           right: 10px;
         }
       }
     }
     .general-form-input {
        input {
          padding: 0 10px;
        }
     }
      .keyword-design {
        margin-bottom: 20px;
        input {
          padding: 0 10px;
        }
        svg {
          right: 25px
        }
      }
      .dropdown-position {
        margin-top: 0px;
      }
      h3 {
        margin: 10px 0 5px 0;
      }
      .search-button {
        margin-top: 55px;
         &.last {
          display: block;
        }
      }
      .postal-code-popover {
        .btn-secondary {
          float: none;
          margin-left: 10px;
          margin-top: -4px;
        }
      }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    margin: 0 15px;
     h2 {
       margin-top: 40px;
     }
     h3 {
       margin: 10px 0 5px 0;
     }
     .more-button {
      margin-bottom: 30px;
     }
     .checkbox-filter {
      display: block;
      width: 100%;
    }
    .keyword-design {
      margin-bottom: 20px;
      input {
        padding: 0 35px 0 15px;
      }
    }
    .search-button {
      margin-top: 30px;
       &.last {
        display: block;
      }
    }
    .dropdown-position {
      margin-top: 0px;
    }
    .conteiner-fluid {
      padding: 0;
    }
    
    .postal-code-popover {
      display: flex;
      justify-content: space-between;
        .btn-secondary {
          float: none;
          margin-left: 10px;
          margin-top: -4px;
        }
    }
  }
`;
export const PopoverBodyStyled = styled(PopoverBody)`
  max-width: 170px;
  color: ${popoverBg};
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  margin: 12px;
  p {
    margin-bottom: 0;
  }
`;

export const UncontrolledPopoverStyledSections = styled(UncontrolledPopover)`
  .popover {
    background-color: ${white};
    color: ${black};
    border: none;
    box-shadow: 0 1px 3px 2px rgba(0, 0, 0, 0.05);
    .popover-inner {
      .popover-header {
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        line-height: 15px;
        color: ${black};
        background-color: ${white};
        border: none;
        padding-top: 20px;
      }
      .popover-body {
        color: ${black};
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        border: none;
        margin: 12px;

        p {
          margin-bottom: 0;
        }
        ul {
          padding: 20px 15px;
          li {
            padding-bottom: 10px;
            strong {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    .popover-inner {
      max-width: 150px;
    }
  }
`;
export const VideoSection = styled.div`
  background-color: ${lgGrey};
  background-color: rgba(144, 158, 158, 0.1);

  .video-col {
    text-align: center;
  }
  .video-play {
    text-align: center;
    padding: 0 15px;
  }
  h2 {
    font-size: 24px;
    padding-top: 60px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .video-text {
    padding: 30px 0 60px 0;
    p {
      text-align: left;
      padding-bottom: 5px;
      margin-bottom: 0;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    margin: 0 10px 0 10px;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    h2 {
      padding-top: 40px;
    }
    .row {
      margin: 0;
    }
    .video-text {
      padding-bottom: 20px;
    }
  }
`;
export const LearnMoreSection = styled.div`
  background-color: ${white};
  background-image: url(/images/logo-symbol-left.png);
  background-position-x: 50px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-y: center;
  align-items: center;
  padding-bottom: 60px;
  .card {
    min-height: 458px;
    border: none;
    background-clip: none;
    border-radius: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 30px 40px 0 rgba(0, 0, 0, 0.2);
  }

  h2 {
    padding: 60px 0 30px;
    text-align: center;
    text-transform: capitalize;
    font-weight: 300;
  }
  h3 {
    display: block;
    font-weight: 300 !important;
    margin: 2rem 2rem 1rem;
    color: ${textRed};
    line-height: 25px;
    text-transform: capitalize;
  }
  h4 {
    margin: 0 2rem 2rem;
  }
  p {
    color: ${textGrey};
    margin: 0 2rem 2rem;
    line-height: 25px;
    min-height: 80px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    background-position-x: -83px;
    background-size: 145%;
    background-position-y: top;
    padding-bottom: 60px;
    .card {
      height: 480px;
    }
    p {
      min-height: 20px;
    }
    div.row {
      margin: 0 10px 0 10px;
    }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    background-position-x: -400px;
    background-position-y: 390px;
    background-size: auto;
    padding-bottom: 0;
    .row {
      margin: 0;
    }
    .card {
      margin-bottom: 30px;
    }
  }
`;

// END OF HOME PAGE SECTION

// START WHAT ARE CLINICAL TRIALS PAGE

export const WhatAreCTHero = styled.div`
  background-color: ${bgPurple};
  background-image: url(/images/logo-symbol-right.png);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-y: -30px;
  color: ${white};
  padding: 60px 0;
  .hero-participate-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h1 {
    text-align: center;
  }
  p {
    text-align: center;
    padding: 20px 0;
    color: ${white};
  }

  .video-play {
    height: 531px;
    width: 100%;
    border: 10px solid ${dirtyWhite};
  }
  .why-hero {
    p {
      padding: 20px 15px 30px 15px;
      margin-bottom: 0;
    }
  }
  @media (min-width: 766px) and (max-width: 1024px) {
    background-size: 160%;
    background-position-y: -17px;
    background-position-x: -220px;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    background-size: 250%;
    background-position-y: -14px;
    background-position-x: -330px;
    padding: 40px 0;
    .hero-participate-row {
      margin: 0;
    }
    p {
      padding: 20px 20px;
    }
    .why-hero {
      p {
        padding: 20px 0 30px 0;
        margin-bottom: 0;
      }
    }
  }
  @media (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    background-size: 250%;
    background-position-y: -25px;
    background-position-x: -600px;
    padding: 40px 0;
  }
`;
export const PhasesSection = styled.div`
  padding: 60px 0;
  h2 {
    text-align: center;
  }
  h3 {
    padding: 30px 0 20px 0;
  }
  p {
    text-align: left;
    padding: 20px 0 30px 0;
    margin-bottom: 0;
  }
  .phases-mainText {
    padding: 20px 0 30px 0;
    text-align: center;
  }
  .phases-card {
    border: none;
    .phases-img {
      min-height: 280px;
    }
    .phases-body {
      // min-height: 250px;
      padding: 0;
      p {
        padding: 0;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .phases-row {
      margin: 0;
    }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    padding: 40px 10px 0 10px;
    h3 {
      padding: 20px 0 20px 0;
    }
    .phases-mainText {
      padding: 20px 0 40px 0;
    }
    .phases-row {
      margin: 0;
    }
    .phases-card {
      padding: 0 20px;
      p {
        margin-bottom: 40px;
      }
    }
  }
`;

export const CardsSection = styled.div`
  background-color: ${textRed};
  padding: 60px 0 45px 0;
  text-align: center;
  h2 {
    text-align: center;
    color: ${white};
    margin-bottom: 20px;
  }
  .tool-download-section {
    margin-bottom: 20px;
    .download-btn {
      color: ${white};
      font-weight: bold;
      background-color: ${lgGreen};
      border: none;
      padding: 15px 30px;
      margin-bottom: 10px;
      text-decoration: none;
    }
    .download-text {
      color: ${white};
      padding: 40px 195px 50px 195px;
      text-align: center;
    }
  }
  .card {
    padding: 0;
    position: relative;
    margin: 15px 0;
    align-items: center;
    &.grey {
      background-image: url(/images/crumpled_paper_light.jpg);
      background-repeat: no-repeat;
      background-size: 130%;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.05), 0 30px 40px 0 rgba(0,0,0,0.2);
    }
    &.white{
      background-color: ${white};
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.05), 0 30px 40px 0 rgba(0,0,0,0.2);
    }
    .card-body {
      min-height: 300px;
      padding: 0;
    }
    .card-title {
      display: flex;
      font-size: 26px;
      text-transform: capitalize;
      text-align: center;
      line-height: 25px;
      padding: 10px 20px;
      margin-top: 125px;
      background-color: ${bgPurple};
      border: none;
      color: white;
    }
    .plus-minus {
      position: absolute;
      top: 30px;
      right: 32px;
      color: ${textLightGrey};
      float: right;
      background-color: transparent;
      border: none;
      outline: none;
      .card-img {
        height: 30px;
        width: 30px;
      }
      &.focus {
        outline: none;
      }
    }
    .plus-minus-to-expect {
      position: absolute;
      top: 30px;
      right: 25px;
      color: ${textLightGrey};
      float: right;
      background-color: transparent;
      border: none;
      outline: none;
      .card-img {
        height: 30px;
        width: 30px;
        &.active {
          outline: none;
        }
      }
      &.focus {
        outline: none;
      }
    }
    .text-box {
      padding: 90px 30px 0 30px;
      align-items: flex-start;
      justify-content: center;
      height: 300px;
      max-width: 350px;
    }
    .text-box-what-to-expect {
       padding: 60px 0 10px 0;
      align-items: flex-start;
      justify-content: center;
      height: 300px;
      max-width: 450px;
    }
  }

  p {
    text-align: left;
    padding: 20px 0;
    margin-bottom: 0;
  }
  
  @media (min-width: 768px) and (max-width: 1024px) {
    .row {
      margin: 0
    }
    .download-text {
    color: ${white};
    padding: 20px 70px;
    text-align: center;
  }
    .card {
      min-height: 400px;
      .plus-minus {
        top: 30px;
        right: 30px;
      }
      .card-title {
        margin-top: 162px;
      }
    }
    .text-box-what-to-expect {
      p {
        max-width: 300px;
        padding-top: 30px;
      }
    }
    .tool-download-section {
      .download-text {
        padding: 40px 100px 50px 100px;
      }
    }
    
  }
  
  @media (min-width: 320px) and (max-width: 767px) {
  padding: 0 0 40px 0;
  .row {
   margin: 0;
  }
  .what-CT-title {
    padding: 40px 0 10px 0;
    margin: 0;
  }
  .what-to-expect-title {
    padding: 60px 0 40px 0;
    margin: 0;
  }
  .what-to-expect-title {
    padding: 40px 0 40px 0;
    margin: 0;
  }
  .tool-download-section {
    .download-text {
      color: ${white};
      padding: 20px 20px 40px 20px;
      text-align: center;
    }
    .download-btn {
      padding: 15px 20px 15px 20px;
    }
  }
  .what-to-expect-card {
   min-height: 400px;
   margin: 10px 0;
    .plus-minus-to-expect {
      top: 30px;
      right: 25px;
    }
    .text-box-what-to-expect {
      max-width: 300px;
      padding: 80px 15px 10px 15px;
      p {
        padding: 0;
        font-size: 14px;
      }
    }
    .card-title {
        margin-top: 162px;
      }
  }
   @media (min-width: 320px) and (max-width: 767px) and (orientation: landscape){
     .what-to-expect-card {
       min-height: 350px;
     }
    
   }
`;
// END OF WHAT ARE CT PAGE

// START WHY PARTICIPATING PAGE STYLE

export const BenefitsCards = styled.div`
  margin: 60px 0 20px 0;
  .row {
    align-items: center;
  }
  h2 {
    text-align: center;
  }
  h3 {
    padding-bottom: 20px;
    text-align: left;
  }
  .main-row {
    margin-top: 30px;
  }
  .card {
    border: none;
    min-height: 300px;
    .order-last-row {
      flex-direction: row-reverse;
    }
    .benefits-img {
      min-height: 264px;
      margin-top: -4px;
    }
    .card-body {
      text-align: left;
      padding: 0;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-bottom: 40px;
    h2 {
      padding-bottom: 20px;
    }
    p {
      margin-bottom: 30px;
    }
    .main-row {
      margin: 0;
      .main-col {
        padding: 10px 30px 30px 30px;
        .benefits-row {
          min-height: 590px;
          .second-text {
            min-height: 273px;
          }
        }
      }
      .card {
        .order-last {
          flex-direction: column-reverse;
        }
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .main-row {
      margin: 0;
      .main-col {
        padding: 0 15px;
        .benefits-row {
          min-height: 318px;
          &.order-last-row {
            .second-text {
              padding-top: 22px;
            }
          }
        }
      }
    }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    margin: 40px 0;
    .main-col {
      padding-top: 40px;
    }
    h2 {
      padding: 0 30px;
    }
    h3 {
      padding: 20px 0;
      white-space: normal;
    }
    .benefits-row {
      margin: 0;
      padding: 0;
      .img-container {
        padding: 0;
      }
      .text {
        padding: 0;
      }
    }
    .order-last-row {
      flex-direction: column-reverse !important;
    }
    .main-row {
      margin: 0 30px;
    }
    p {
      margin-bottom: 0;
    }
  }
  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    .main-row {
      .main-col {
        .benefits-row {
          min-height: 394px;
        }
      }
    }
  }
`;
export const ReviewSection = styled.div`
  background-color: rgba(144, 158, 158, 0.1);
  padding: 60px 0;
  .review-col {
    padding: 30px;
  }
  h2 {
    text-align: center;
  }
  p {
    // font: italic 16px/25px Roboto;
    font-style: italic;
    text-align: center;
  }
  ul {
    text-align: center;
    color: ${textRed};
    font-weight: bold;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    display: none;
  }
`;

export const ReviewSectionMobile = styled.div`
  display: none;
  @media (min-width: 320px) and (max-width: 767px) {
    display: block;
    padding: 40px 0 50px 0 !important;
    background-color: rgba(144, 158, 158, 0.1);
    .carousel-indicators {
      bottom: -20px;
      li {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${textLightGrey};
      }
    }
    .carousel-item {
      min-height: 180px;
      padding: 20px 40px;
    }
    .carousel-inner {
      min-height: 200px;
      max-height: 200px;
    }
    .carousel-control-next-icon {
      background-image: url(/images/next-icon.png);
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .carousel-control-prev-icon {
      background-image: url(/images/prev-icon.png);
      background-repeat: no-repeat;
      background-size: 100%;
    }
    padding: 60px 0;
    .review-col {
      padding: 30px;
    }
    h2 {
      text-align: center;
    }
    p {
      font: italic 16px/25px Roboto;
      text-align: center;
    }
    ul {
      text-align: center;
      color: ${textRed};
      font-weight: bold;
    }
  }
`;

// START WHAT TO EXPECT STYLE

export const ExpectHeroArea = styled.div`
  background-color: ${bgPurple};
  background-image: url(/images/logo-symbol-right.png);
  background-position-x: -120px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-y: center;
  position: relative;
  color: ${white};
  width: 100%;
  padding: 60px 0;
  text-align: center;
  align-items: center;
  display: flex;

  p {
    color: ${white};
    margin: auto;
    width: 60%;
    padding: 20px 0;
  }
  .hero-download-btn {
    margin: 30px 0 15px 0;
  }
  .faqs-hero {
    h1 {
      padding-bottom: 20px;
    }
    p {
      padding: 0 0 10px 0;
      width: 66%;
    }
  }
  .download-btn {
    color: ${white};
    font-weight: bold;
    background-color: ${lgGreen};
    border: none;
    margin-top: 30px;
    padding: 15px 30px;
    margin-bottom: 10px;
    text-decoration-line: none;
    text-decoration: none;
    &:hover {
      text-decoration-line: underline;
      text-decoration: underline;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    background-position-x: 50px;
    p {
      width: 80%;
    }
  }
  @media (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    background-size: 250%;
    background-position-y: -20px !important;
    background-position-x: -400px !important;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    background-size: 250%;
    background-position-y: 0;
    background-position-x: -300px;
    p {
      color: ${white};
      padding: 20px 20px;
      // margin: 20px 40px;
      width: 100%;
      margin: 0;
    }
    .faqs-hero {
      h1 {
        padding-bottom: 20px;
      }
      p {
        padding: 0 15px 10px 15px;
        width: 100%;
      }
    }
  }
`;
export const WhatHappenSection = styled.div`
  padding: 60px 0;
  .what-happen-main-row {
    margin: 15px 0;
  }
  .card-body {
    padding: 0;
  }
  .what-happens-secondary-row {
    align-items: center;
    margin: 20px 0;
    .gatsby-image-wrapper {
      min-height: 262px;
      min-width: none;
      max-height: 262px;
      max-width: 262px;
    }
  }
  .card {
    background-clip: none;
    border: none;
    border-radius: 0;
  }
  h2 {
    text-align: center;
    padding-bottom: 20px;
  }
  h3 {
    padding: 15px 0;
  }

  p {
    text-align: left;
  }

  @media (min-width: 992px) and (max-height: 800px) {
    .what-happens-text {
      padding-left: 50px !important;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .what-happens-main-row {
      margin: 0;
    }
    .what-happens-secondary-row {
      .what-happens-text {
        padding-left: 0;
      }
    }
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 30px 0 0 0;

    .what-happens-main-row {
      margin: 0;
      padding: 10px 30px;
      .gatsby-image-wrapper {
        min-height: 262px;
        min-width: none;
        max-height: none;
        max-width: none;
      }
    }
    h2 {
      padding: 10px 0;
    }
    h3 {
      padding: 20px 0;
    }
  }
`;

//Start FAQs Page Design
export const FaqsSectionsStyle = styled.div`
  padding: 60px 0;
  width: 60%;
  margin: auto;
  justify-content: center;
  .categories {
    text-align: center;
    padding-bottom: 20px;
  }
  .card-body {
    padding-top: 0;
    .section-card-body {
      p {
        color: ${textDarkGrEy};
      }
    }
  }

  .section-title-button {
    text-align: left;
    width: 100%;
    background-color: ${lgGrey2};
    margin: 5px 0 9px 0;
    padding: 13px 15px;
    border: none;
    &.active {
      background-color: ${bgPurple};
    }
    &:focus {
      outline: none;
    }
    svg {
      float: right;
      font-size: 18px;
    }
    h2 {
      font-size: 22px;
    }
  }
  .sub-title {
    color: ${black};
    line-height: 24px;
    &:focus {
      outline: none;
    }
    svg {
      font-size: 18px;
    }
  }
  a {
    text-decoration: none;
    text-transform: none;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    width: 80%;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 40px 15px;
    margin: 0;
    width: 100%;
  }
`;
// Search Result Page style

export const SearchResultPage = styled.div`
  padding: 60px 0 0 0;
  .result-title {
    font-size: 26px;
    color: ${textRed};
  }
  .title-section {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .filter-button {
      display: flex;
    }
    p {
      margin: 0 5px;
      color: ${lightOrange};
      text-decoration-line: underline;
    }
  }

  .pagination-info {
    font-weight: bold;
    margin-top: 60px;
    margin-bottom: 20px;
  }
  .pagination-col {
    text-align: right;
    font-weight: bold;
    margin-top: 60px;
    margin-bottom: 20px;
    .current-page {
      padding: 0 10px;
    }
    button {
      background: ${lightOrange};
      border: none;
      width: 18px;
      height: 18px;
      padding: 0;
      font-size: 18px;
      svg {
        padding-bottom: 1px;
        color: ${white};
      }
      &:focus {
        outline: none;
        border: none;
      }
    }
  }
  @media (min-width: 481px) and (max-width: 767px) {
    .title-section {
      padding: 0 20px 0 20px !important;
    }
  }
`;

export const ResultsTable = styled.div`
  padding: 20px 0;
  .no-results-message {
    color: ${textRed};
    text-align: center;
  }

  .search-edit {
    border: none;
    font-size: 16px;
    color: ${white};
    width: 100%;
    padding: 15px 0;
    background-color: ${lgGreen};
    a {
      color: ${white};
      text-transform: uppercase;
    }
  }
  .status-line {
    margin: 0 30px;
    background-color: ${white};
    font-size: 16px;
    color: ${textRed};
    height: 40px;
    line-height: 40px;
    box-shadow: 0 1px 0 0 rgba(27, 27, 27, 0.1);
    th {
      &.sortable {
        cursor: pointer;
        white-space: nowrap;
      }
    }
    .title-align {
      text-align: left;
      white-space: nowrap;
      // &.sortable {
      //   padding-left: 10px;
      // }
      &.conditions {
        padding-left: 20px;
      }

      &.sortable:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .result-row {
    height: 130px;
    width: 100%;
    font-size: 14px;
    box-shadow: 0 1px 0 0 rgba(27, 27, 27, 0.1);
    .status-col {
      padding: 0;
      margin-right: -15px;
    }

    .condition-section {
      text-align: left;
      line-height: 18px;
      font-weight: 600;
      width: 30%;
      padding: 30px 20px 0 20px;
      vertical-align: top;
    }

    .status-section {
      width: 15%;
      vertical-align: top;
      .status-row {
        width: 100%;
        .margin: 0;
      }

      .status-icons {
        height: 30px;
        width: 30px;
        background-position-x: 0;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position-y: center;
        display: inline-block;
        margin-top: 30px;
      }
      .status-button {
        background-color: transparent;
        text-align: left;
        border: none;
        color: ${black};
        text-transform: capitalize;
        line-height: 18px;
        padding-top: 30px;
      }
    }

    .requirements-section {
      width: 20%;
      .results-ageRange {
        font-weight: bold;
      }

      .requirements-row {
        width: 100%;
        margin: 0;
        .icon-requirements {
          background-position-x: 0px;
          background-repeat: no-repeat;
          background-position-y: center;
          background-size: 30px;
          height: 30px;
          width: 30px;
          margin-top: 31px;
          padding: 0;
          margin-right: -14px;
        }
      }
      .text-requirements {
        line-height: 16px;
        margin-top: 31px;
        padding: 0;
      }
    }

    .distance-section {
      white-space: nowrap;
      width: 15%;
      max-width: 150px;
      vertical-align: top;
      padding-top: 30px;
      &.alt-text {
        white-space: normal;
        line-height: 16px;
      }
    }
    .details-section {
      text-align: center;
      white-space: nowrap;
      vertical-align: top;
      width: 10%;
      .links {
        line-height: 30px;
        color: ${white};
        text-decoration: none;
        font-weight: bold;
        width: 122px;
        height: 30px;
        margin: 5px 20px;
        // padding: 0 20px;
        display: block;
        &.learn-more {
          background-color: ${blue};
          margin-top: 30px;
        }
      }
    }
  }
  .result-second-row {
    height: 48px;
    box-shadow: 0 1px 0 0 rgba(27, 27, 27, 0.1);
    border-top: 1px solid rgba(27, 27, 27, 0.1);
    td {
      padding: 20px 15px 20px 15px;
    }
    .line-elipsis {
      width: 95%;
      display: inline-block;
      font-size: 13px;
      line-height: 18px;
    }
    .arrow {
      display: inline-block;
    }
  }

  .row-paired {
    background-color: ${rowBg};
    box-shadow: 0 1px 0 0 rgba(27, 27, 27, 0.1);
    border-bottom: 1px solid rgba(27, 27, 27, 0.1);
    border-top: 1px solid rgba(27, 27, 27, 0.1);
  }
  .page-link {
    width: 34px;
    background-color: ${white};
    color: ${textLightGrey};
  }
  .page-item.active .page-link {
    background-color: ${bgPurple};
    color: ${white};
    border: 1px solid ${bgPurple};
    outline: none;
  }
  .page-item.disabled .page-link {
    display: none;
  }
  .pagination {
    padding: 15px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .result-row .status-section .status-button .long-text {
      float: none;
    }
  }
  @media (min-width: 985px) and (max-width: 1024px) {
    .status-button {
      padding-top: 30px !important;
    }
  }

  @media screen and (max-width: 40em) {
    .result-row {
      height: auto;
    }
    padding: 0 !important;
    margin: 0;
    .status-line {
      display: none;
    }
    .table-body {
      border-top: 1px solid ${lgGrey};
    }
    .responsiveTable tbody tr {
      padding-bottom: 20px;
      height: auto;
      border-bottom: 1px solid ${lgGrey};
      border-top: none;
      border-left: none;
      border-right: none;
      width: 100% !important;
      .tdBefore {
        color: #e94e38;
        font-weight: 300;
      }
    }
    .result-row {
      .status-section {
        width: auto;
        padding-right: 10px;
        padding-top: 20px;
        button {
          width: 100%;
        }
        .status-row {
          .status-col {
            display: inline-block;
            width: auto;
            margin-right: 4px;
            margin-left: 13px;
            .status-icons {
              margin-top: 0;
            }
            .status-button {
              padding-top: 0;
            }
          }
        }
      }
      .requirements-section {
        display: inline-block;
        .requirements-row {
          margin-top: 10px;
          display: block;
          .icon-requirements {
            margin-top: 0;
          }
          .text-requirements {
            whit-space: nowrap;
            margin-top: 10px;
            width: 100%;
            .results-ageRange {
              white-space: nowrap;
            }
            .results-gender {
              white-space: nowrap;
            }
          }
        }
      }

      .distance-section {
        width: 100% !important;
        max-width: initial;

        &.alt-text {
          font-size: 14px;
          line-height: 18px;
        }

        svg {
          display: none;
        }
      }

      .details-section {
        width: 100%;
        .tdBefore {
          margin-top: -15px;
        }
        .learn-more {
          margin-top: 10px !important;
        }
        .links {
          margin: 5px 0;
          width: 100%;
          display: inline-block;
          // line-height: 50px;
          text-align: center;
        }
      }
      .sort-suggestion {
        display: none;
      }
    }
    .result-second-row {
      height: 48px;
      box-shadow: 0 1px 0 0 rgba(27, 27, 27, 0.1);
      td {
        padding: 10px 15px 10px 15px;
      }
      .line-elipsis {
        width: 94%;
        display: inline-block;
        font-size: 13px;
        line-height: 18px;
      }
      .arrow {
        display: inline-block;
      }
    }
  }
  @media (min-width: 668px) and (max-width: 985px) {
    .status-button {
      padding-top: 0px !important;
    }
    .text-requirements {
      margin-top: 0px !important;
    }
  }
`;

// DETAIL PAGE STYLE

export const DetailsHero = styled.div`
  background-color: ${bgPurple};
  color: ${white};
  width: 100%;
  font-weight: 300;
  .detail-hero-main-row {
    padding: 0 30px;
  }
  .go-back-button {
    font-size: 14px;
    font-weight: 300;
    line-height: 16px;
    text-decoration: underline;
    background: transparent;
    border: none;
    color: ${white};
    padding: 30px 0;
  }
  .hero-title-col {
    margin-top: -60px;
  }

  .overall-section {
    line-height: 36px;
    display: flex;
    align-items: center;
    .status-icons {
      height: 36px;
      width: 36px;
      min-height: 36px;
      min-width: 36px;
      background-position-x: 0;
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: center;
      display: inline-block;
    }
    .overall-status {
      display: inline-block;
      font-size: 24px;
      font-weight: 300;
      line-height: 36px;
      margin-left: 10px;
    }
    button {
      display: inline-block;
      background-color: transparent;
      border: none;
      line-height: 18px;
      align-self: self-start;
      svg {
        color: ${white};
        font-size: 16px;
      }
    }
  }
  .details-title {
    padding: 30px 0 10px 0;
  }
  .main-description {
    line-height: 24px;
  }

  .identifier-section {
    padding: 30px 0;
    white-space: nowrap;
    width: 130%;
    h3 {
      font-size: 16px;
      font-weight: 300;
      font-weight: bold;
      color: ${white};
      line-height: 19px;
      display: inline-block;
    }
    button {
      display: inline-block;
      background-color: transparent;
      border: none;
      line-height: 19px;
      vertical-align: baseline;
      svg {
        color: ${white};
        font-size: 16px;
      }
    }
    a {
      color: ${white};
    }
  }
  .modal-btn {
    padding-left: 0;
    font-weight: 300;
    margin-bottom: 60px;
  }
  .mobile-social {
    display: none;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    padding: 10px 15px 40px 15px;
    .desktop-social {
      display: none;
    }
    .mobile-social {
      align-items: center;
      display: flex;
    }
    .hero-title-col {
      margin-top: 0;
    }
    .identifier-section {
      width: 100%;
      .clinicalId-col {
        margin-right: 15px;
      }
    }
    .details-title {
      padding: 30px 0 10px 0;
    }
    .modal-btn {
      margin-bottom: 20px;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .identifier-section {
      width: 130% !important;
    }
    .hero-title-col {
      margin-top: 0;
    }
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 10px 15px 40px 15px;
    .status-bar-desktop {
      padding-right: 0;
    }
    .desktop-social {
      display: none;
      padding: 0;
    }
    .mobile-social {
      display: flex;
    }
    .hero-title-col {
      margin-top: 0;
    }
    .detail-hero-main-row {
      padding: 0 0;
      .detail-hero-main-col {
        padding: 0 0;
      }
    }
    .identifier-section {
      padding-bottom: 15px;
      width: 100%;
      .id-cols {
        padding-bottom: 15px;
      }
    }
    .modal-btn {
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 15px;
      .ask-to-join {
        width: 122px;
        height: 50px;
      }
    }
  }

  //iPAD PrO

  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    .detail-hero-main-col {
      // max-width: 100%;
      // flex: 0 0 100%;
    }
    .hero-title-col {
      margin-top: -60px;
    }
    .desktop-social {
      display: flex;
    }
    .mobile-social {
      display: none;
    }
    .identifier-section {
      width: 130% !important;
    }
  }
`;
export const TrialPurposeStyle = styled.div`
  padding: 60px 0;
  background-color: #f9f9f9;
  .requirements-row {
    padding: 0 30px 30px 30px;
    color: ${white};
    align-items: center;
    .gender-icon {
      height: 50px;
      width: 50px;
      background-position-x: 0;
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: center;
      max-width: 50px;
      flex: 0 0 100%;
    }
    .text-requirements {
      font-size: 22px;
      line-height: 24px;
      .results-ageRange {
        font-weight: bold;
      }
    }
  }
  .trial-purpose-row {
    .purpose-title {
      padding-top: 20px;
    }
  }
  .key-participation {
    background-color: ${textRed};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 10px 40px 0 rgba(0, 0, 0, 0.2);
    h3 {
      font-size: 18px;
      color: ${white};
      padding: 30px;
    }
  }
  .criteria-section {
    padding: 30px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 10px 40px 0 rgba(0, 0, 0, 0.2);
    max-height: 400px;
    overflow: hidden;
    h3 {
      font-size: 18px;
      line-height: 21px;
    }
    .exclusion-title {
      margin-top: 20px;
    }
    .criteria-text {
      padding: 20px 0;
      font-weight: 300;
      overflow: hidden;
      max-height: 120px;
      line-height: 24px;
    }
    .ask-to-join {
      float: right;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    padding-bottom: 0;
    background-color: ${white};
    .trial-purpose-row {
      .purpose-title {
        padding-top: 0;
        padding-bottom: 30px;
        text-align: center;
      }
      .requirements-row {
        position: relative;
        .gender-icon {
          position: absolute;
          top: 30px;
          left: 30px;
        }
        .text-requirements {
          position: absolute;
          top: 30px;
          left: 80px;
        }
      }
      .key-participation {
        h3 {
          font-size: 18px;
          color: ${white};
          padding: 30px 15px 30px 15px;
        }
      }
      .criteria-section {
        .exclusion-title {
          margin-top: 0;
        }
      }
    }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    padding: 40px 15px 40px 15px;
    margin: 0;
    .trial-purpose-row {
      .purpose-title {
        padding-top: 0;
        padding-bottom: 30px;
        text-align: center;
      }
      .key-participation {
        height: 180px;
        box-shadow: none;
        h3 {
          padding: 30px 0 0 30px;
        }
        .requirements-row {
          position: relative;
          .gender-icon {
            position: absolute;
            top: 30px;
            left: 30px;
          }
          .text-requirements {
            position: absolute;
            top: 30px;
            left: 90px;
          }
        }
      }
      .criteria-section {
        // box-shadow: none;
        max-height: 472px;
        .exclusion-title {
          margin-top: 0;
        }
        .criteria-text {
          max-height: 160px;
          overflow: -webkit-paged-x;
          overflow: -moz-paged-x;
        }
      }
    }
  }

  // Ipad PRO

  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    .trial-purpose-row {
      .purpose-title {
        padding-top: 20px;
      }
    }
  }
`;

export const TrialSummaryStyle = styled.div`
  border-bottom: 1px solid #deddd1;
  padding: 60px 0 30px 0;
  .trial-summary-row {
    h2 {
      padding-top: 20px;
    }
  }
  .detail-card {
    height: 227px;
    min-width: 261px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 30px 40px 0 rgba(0, 0, 0, 0.2);
    margin-bottom: 30px;
    border: none;
    .card-body {
      text-align: right;
      .details-section {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
      }
      .popover-btn {
        background-color: transparent;
        border: none;
        svg {
          font-size: 16px;
        }
      }
      .p-big-font {
        font-size: 42px;
        text-align: center;
        font-weight: bold;
        padding: 50px 0 0 0;
      }
      
      .accept {
        margin-bottom: 10px;
        padding-top: 40px !important;
      }
     
      .accept-text {
        text-align: center;
        line-height: 19px;
      }
      .p-small-text {
        padding-top: 50px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        &.infoIcon {
          padding-left: 24px;
        }
        .popover-btn {
          background-color: transparent;
          border: none;
          padding-right: 0;
          vertical-align: text-bottom;
          svg {
            font-size: 16px;
          }
        }  
      }
      
      .dates {
        text-align: center;
        padding-top: 50px;
        font-size: 22px;
        time {
          font-size: 18px;
          font-weight: 500;
          padding: 0 15px;
        }
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
  padding-top: 30;
    .trial-summary-row {
      h2 {
        padding-top: 0;
        padding-bottom: 30px;
        text-align: center;
      }
    }
    .detail-card {
      min-width: 200px;
      .card-body {
        .p-big-font {
          font-size: 42px;
          text-align: center;
          font-weight: 500;
          padding: 47px 0 0 0;
          &.accept {
            margin-bottom: 8px;
            padding-top: 20px;
          }
        }
        .p-small-text {
          padding-top: 47px;
        }
        .dates {
          padding-top: 47px;
        }
      }
    }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    padding: 40px 40px 20px 40px;
    .trial-summary-row {
      h2 {
        padding-top: 0;
        padding-bottom: 20px;
        text-align: center;
      }
    }
    .detail-card {
    .card-body {
      .popover-btn {
        background-color: transparent;
        border: none;
        svg {
          font-size: 18px;
        }
      }
      .p-big-font {
        padding: 40px 0 0 0;
         &.accept {
            margin-bottom: 10px;
            padding-top: 30px;
          }
      }
      .p-small-text {
        padding-top: 40px;
      }
      .dates {
        padding-top: 40px;
      }
    }
  }
  // Ipad PRO
  
 @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
   .trial-summary-row {
     h2 {
      padding-top: 20px;
     }
   }
 }
`;

export const OutcomeSection = styled.div`
background-color: ${bgPurple};
padding: 60px 0 48px 0;
  .primary-outcome {
    border-bottom: 1px solid #deddd1;
    padding-bottom: 10px;
    
    h2 {
      padding-bottom: 20px;
      display: inline-block;
    }
  }
  .secondary-outcome {
    padding-top: 10px;
    
    h2 {
      padding: 20px 0;
      display: inline-block;
    }  
  }
  h3 {
    color: ${white};
    font-size: 16px;
    line-height: 24px;
    font-weight 500;
  }
  p {
    color: ${white};
    line-height: 24px;
    margin-bottom: 12px;
  }
  .popover-btn {
    background-color: transparent;
    border: none;
    vertical-align: text-bottom;
    height: 50px;
    svg {
      font-size: 16px;
    }
  }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    padding: 60px 30px 48px 30px;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    padding: 40px 0 28px 0;
  }
`;
export const TrialDesignStyle = styled.div``;
export const MapSectionStyle = styled.div`
  background-color: ${textRed};
  padding: 60px 80px;
  h2 {
    font-size: 26px;
    color: white;
    line-height: 30px;
    padding-bottom: 30px;
    font-weight: 300;
  }
  strong {
    font-weight: bold;
  }
  .location-holder {
    max-height: 600px;
    min-height: 600px;
    background-color: ${white};
    overflow: auto;
  }
  .map-holder {
    padding-right: 0;
  }

  .map-locations {
    height: 600px;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    .map-locations {
      height: 400px;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    h2 {
      text-align: center;
    }
    .map-holder {
      padding-right: 0;
      padding-left: 0;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
  // IPAD Pro

  @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 40px 15px;
    h2 {
      text-align: center;
    }
    .map-holder {
      padding-right: 0;
      padding-left: 0;
    }
    .location-holder {
      min-height: auto;
      overflow: scroll;
    }
  }
`;

export const DetailsSocialStyle = styled.nav`
text-align: right;
padding-top: 70px;
.share-mobile {
    background-color: ${orange};
    color: ${white};
    position: relative;
    height: 26px;
    width: 26px;
    border: none;
    border-radius: 50%;
    svg {
      font-size: 15px;
      position: absolute;
      top: 6px;
      right: 6px;
    }
  }
p {
  margin-bottom: 5px;
}
.media-row {
  text-align: right;
  justify-content: flex-end;
  margin-left: 54px;
  margin-right 0;
  // float: right;
  .media-col {
    padding-right: 1px;
    padding-left: 1px;
    // margin: 0 10px;
    
    .social-logo {
      height: 40px;
      width: 40px;
      margin: 0 10px;
      border-radius: 15%;
      border: 1px solid transparent;
      &.facebook {
        background-image: url(/images/facebook.svg);
        background-position-x: 0;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: center;
      }
      &.linkedIn {
        background-image: url(/images/Linkedin.svg);
        background-position-x: 0;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: center;
      }
      &.twitter {
        background-image: url(/images/Twitter.svg);
        background-position-x: 0;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: center;
      }
      &.mail-to {
        background-image: url(/images/mail.svg);
        background-position-x: 0;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: center;
      }
      &.print {
        background-image: url(/images/PrintFile.svg);
        background-position-x: 0;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: center;
        margin-right: 0;
      }
    }
    .print-button {
      background-color: transparent;
      border: none;
      padding: 0;
    }
  }
}
  @media (min-width: 768px) and (max-width: 1024px) {
    display: none;
  }
   @media (min-width: 320px) and (max-width: 767px) {
    display: none;
  }
  
  @media only screen 
  and (min-width: 1024px) 
  and (max-height: 1366px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1.5) {
    display: block;
  }
`;
export const LocationTableRow = styled.div`
  background-color: ${white};
  .result-row-location {
    color: ${black};
    background-color: ${white};
    .section-location {
      padding: 0 30px;
      width: 100%;
      .location-subtitle {
        border-top: 1px solid #e5e5e5;
        font-weight: bold;
        padding: 30px 0 5px 0;
        line-height: 21px;
        font-size: 18px;
      }
      .address {
        line-height: 19px;
        font-size: 16px;
        padding-top: 5px;
      }
    }
    .section-status {
      position: relative;
      width: 100%;
      padding: 20px 0;
      .status-text {
        margin: 0 0 0 10px;
        font-size: 14px;
        width: min-content;
      }
      .ask-to-join {
        position: absolute;
        top: 6px;
        right: 0;
        width: 120px;
      }
      .contact-us {
        position: absolute;
        top: 6px;
        right: 0;
        width: 120px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
  // IPAD Pro

  @media only screen and (min-width: 768px) and (max-width: 1299px) {
    .result-row-location {
      .section-status {
        .status-text {
          min-width: 80px;
        }
      }
    }
  }

  @media only screen and (min-width: 1300px) {
    .result-row-location {
      .section-status {
        .status-text {
          white-space: nowrap;
        }
      }
    }
  }

  @media only screen and (max-width: 992px) {
    .result-row-location {
      .section-status {
        .status-text {
          white-space: nowrap !important;
        }
      }
    }
  }

  @media (min-width: 320px) and (max-width: 767px) {
    .location-holder {
      padding-left: 15px;
    }
    .result-row-location {
      .section-status {
        .status-text {
          white-space: normal !important;
        }
      }
    }
  }
`;

export const MapStyle = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 15px;
  align-items: center;
  h2 {
    margin: 40px 0;
  }
  li {
    margin-bottom: 10px;
    line-height: 1.2;
    a {
      text-decoration: none;
      color: #ee7624;
      :hover {
        color: #ca641e;
      }
    }
  }
`;
